import React from "react";

import { KeyValuePair, TableColumn } from "../../../../../models";
import { T } from "../../../../../constants/translation-keys";
import { TableColumnsRow } from "./table-columns-row";
import { Loader } from "../../loader";
import TableBody from "./table-body";

interface TableMainContentProps {
  rowKey?: string;
  loading?: boolean;
  rowClicked: boolean;
  rowClickedKey: string;
  isDrawPrintIcon?: boolean;
  rows: Array<KeyValuePair>;
  hideColumnHeaders: boolean;
  columns: Array<TableColumn>;
  openJackpotStream?: (row?: any) => void;
  onRowClick: (row: any, index: number) => void;
}

export const TableMainContent: React.FC<TableMainContentProps> = ({
  rows,
  rowKey,
  columns,
  loading,
  rowClicked,
  onRowClick,
  rowClickedKey,
  isDrawPrintIcon,
  hideColumnHeaders,
  openJackpotStream,
}) => {
  return (
    <div className="main-structure-table-wrapper">
      <div className="main-table-wrapper">
        {loading && <Loader text={T.PLEASE_WAIT_FOR_LOADER} />}
        {
          !hideColumnHeaders && (
            <TableColumnsRow
              columns={columns}
              isDrawPrintIcon={isDrawPrintIcon}
              isDrawJackpot={!!openJackpotStream}
            />
          )
        }
        <TableBody
          rows={rows}
          rowKey={rowKey}
          columns={columns}
          rowClicked={rowClicked}
          onRowClick={onRowClick}
          rowClickedKey={rowClickedKey}
          isDrawPrintIcon={isDrawPrintIcon}
          openJackpotStream={openJackpotStream}
        />
      </div>
    </div>
  );
};
